import script from "./PerformerProjectsLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./PerformerProjectsLayout.vue?vue&type=script&setup=true&lang=js"

import "./PerformerProjectsLayout.vue?vue&type=style&index=0&id=1651ea80&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1651ea80"]])

export default __exports__